$(document).on('click','.item-btn-question', function() {
     
    const itemnr = $(this).attr('data-itemnr');
    const loadingIcon = 'fa fa-circle-o-notch fa-spin fa-fw mr-2';
    const questionIcon = 'fa fa-question-circle-o mr-2';
    const _this = this;
    
    if($('.modal-question').length <= 0){
        $(this).find('i').removeClass(questionIcon).addClass(loadingIcon);
        $.get('/rest/item-question/?itemnumber=22', function( data ) {
            var parsedData = JSON.parse(data);
            var ItemQuestionComponent = Vue.extend({
                template: parsedData.data.itemQuestionForm
            })
            Vue.component('itemquestion-component', ItemQuestionComponent)
            var compiledItemQuestion = new ItemQuestionComponent().$mount();
            //$('.placeholder-nav-items-28').html(compiledItemQuestion.$el);
            $('body').append(compiledItemQuestion.$el);
            $('#Artikelnummer').val(itemnr);
            $('#Artikelnummer').attr('readonly',true)
            $('.modal-question').modal();
            $(_this).find('i').removeClass(loadingIcon).addClass(questionIcon);
            initFormEvent();
        });
    }else{
        $('.modal-question').modal();
    }

});

function initFormEvent(){
    const form = document.querySelector(".modal-question form");
    form.addEventListener("submit", function(event){
        ceresStore.dispatch('sendContactForm', event);
    });
}